module.exports = __webpack_public_path__ + "static/media/applicationLogotype.1eff3543.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicationLogotype.svg
// module id = 606
// module chunks = 0